import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const FinanceSidebar = () => {
  const [financeOpen, setFinanceOpen] = useState(true);
  const [salesOpen, setSalesOpen] = useState(true);
  const [mastersOpen, setMastersOpen] = useState(true);

  return (
    <aside style={sidebarStyle}>
      {/* =========================
          FINANCE
      ========================== */}
      <MenuHeader
        icon="💰"
        title="Finance"
        open={financeOpen}
        onClick={() => setFinanceOpen((prev) => !prev)}
      />

      {financeOpen && (
        <div style={menuGroupStyle}>
          <SidebarLink to="/Finance/entry" icon="💳">
            Finance Entry
          </SidebarLink>
        </div>
      )}

      {/* =========================
          SALES
      ========================== */}
      <MenuHeader
        icon="💼"
        title="Sales"
        open={salesOpen}
        onClick={() => setSalesOpen((prev) => !prev)}
      />

      {salesOpen && (
        <div style={menuGroupStyle}>
          <SidebarLink to="/Finance/sales-dashboard" icon="📊">
            Sales Dashboard
          </SidebarLink>

          {/* =========================
              MASTERS
          ========================== */}
          <div
            onClick={() => setMastersOpen((prev) => !prev)}
            style={subSectionStyle}
          >
            <div style={menuTitleWrapStyle}>
              <span style={menuIconStyle}>📁</span>
              <span>Masters</span>
            </div>

            <span style={arrowStyle}>{mastersOpen ? "▲" : "▼"}</span>
          </div>

          {mastersOpen && (
            <div style={masterWrapperStyle}>
              <SidebarSubLink
                to="/Finance/sales-master/service-master"
                icon="🛠️"
              >
                Service Master
              </SidebarSubLink>

              <SidebarSubLink
                to="/Finance/sales-master/client-master"
                icon="👥"
              >
                Client Master
              </SidebarSubLink>

              <SidebarSubLink
                to="/Finance/sales-master/bank-detail-master"
                icon="🏦"
              >
                Bank Detail Master
              </SidebarSubLink>

              <SidebarSubLink
                to="/Finance/sales-master/terms-conditions"
                icon="📋"
              >
                Terms & Conditions
              </SidebarSubLink>
            </div>
          )}

          {/* =========================
              SALES DOCUMENTS
          ========================== */}
          <div style={smallDividerStyle} />

          <SidebarLink to="/Finance/quotations" icon="📝">
            Quotations
          </SidebarLink>

          <SidebarLink to="/Finance/proforma-invoices" icon="📄">
            Proforma Invoices
          </SidebarLink>

          <SidebarLink to="/Finance/invoices" icon="🧾">
            Invoices
          </SidebarLink>
        </div>
      )}
    </aside>
  );
};

/* =====================================================
   SMALL COMPONENTS
===================================================== */

const MenuHeader = ({ icon, title, open, onClick }) => {
  return (
    <div onClick={onClick} style={sectionStyle}>
      <div style={menuTitleWrapStyle}>
        <span style={menuIconStyle}>{icon}</span>
        <span>{title}</span>
      </div>

      <span style={arrowStyle}>{open ? "▲" : "▼"}</span>
    </div>
  );
};

const SidebarLink = ({ to, icon, children }) => {
  return (
    <NavLink to={to} style={linkStyle}>
      <span style={linkContentStyle}>
        <span style={menuIconStyle}>{icon}</span>
        <span>{children}</span>
      </span>
    </NavLink>
  );
};

const SidebarSubLink = ({ to, icon, children }) => {
  return (
    <NavLink to={to} style={subLinkStyle}>
      <span style={linkContentStyle}>
        <span style={subIconStyle}>{icon}</span>
        <span>{children}</span>
      </span>
    </NavLink>
  );
};

/* =====================================================
   STYLES
===================================================== */
const sidebarStyle = {
  width: "235px",
  minWidth: "235px",
  minHeight: "100%",
  background: "#DDF3F1",
  color: "#163B3A",
  padding: "14px 10px 20px",
  boxSizing: "border-box",
  borderRight: "1px solid #B8DFDB",
  fontFamily: "Inter, Segoe UI, Arial, sans-serif",
};

const sectionStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "11px 13px",
  marginTop: "5px",
  marginBottom: "4px",
  fontWeight: 800,
  fontSize: "14px",
  cursor: "pointer",
  borderRadius: "8px",
  userSelect: "none",
  color: "#164E4A",
  background: "#C8EAE6",
  transition: "all 0.18s ease",
};

const subSectionStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 12px 10px 14px",
  margin: "5px 0",
  fontWeight: 800,
  fontSize: "13px",
  cursor: "pointer",
  borderRadius: "7px",
  userSelect: "none",
  color: "#164E4A",
  background: "#C8EAE6",
};

const menuGroupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
};

const linkStyle = ({ isActive }) => ({
  display: "block",
  padding: "10px 12px",
  margin: "2px 0",
  textDecoration: "none",

  color: isActive ? "#ffffff" : "#245653",

  borderRadius: "7px",

  background: isActive ? "#3D8F89" : "transparent",

  fontSize: "13px",
  fontWeight: isActive ? 800 : 650,
  lineHeight: "1.2",

  transition: "all 0.18s ease",

  boxShadow: isActive ? "0 2px 7px rgba(61,143,137,0.22)" : "none",
});

const masterWrapperStyle = {
  marginLeft: "15px",
  paddingLeft: "10px",
  borderLeft: "2px solid #AFDCD8",
};

const subLinkStyle = ({ isActive }) => ({
  display: "block",
  padding: "9px 10px",
  margin: "2px 0",
  textDecoration: "none",

  color: isActive ? "#ffffff" : "#315F5C",

  borderRadius: "6px",

  background: isActive ? "#58A39D" : "transparent",

  fontSize: "12.5px",
  fontWeight: isActive ? 800 : 600,
  lineHeight: "1.2",

  transition: "all 0.18s ease",
});

const menuTitleWrapStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minWidth: 0,
};

const linkContentStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const menuIconStyle = {
  width: "18px",
  minWidth: "18px",
  textAlign: "center",
  fontSize: "13px",
};

const subIconStyle = {
  width: "16px",
  minWidth: "16px",
  textAlign: "center",
  fontSize: "12px",
};

const arrowStyle = {
  fontSize: "10px",
  color: "#315F5C",
  opacity: 0.9,
};

const smallDividerStyle = {
  height: "1px",
  background: "#B8DFDB",
  margin: "7px 8px",
};

export default FinanceSidebar;
